import { Form } from '@formio/react'
import Select from 'react-select'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'

import { CModal, CModalHeader, CModalTitle, CModalFooter, CModalBody, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormText, CContainer } from '@coreui/react'
import { CCol, CRow, CCard, CCardBody, CFormLabel, CFormInput, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CButtonGroup, CCardTitle, CCardText, CCardImage, CButton, CFormSelect, CCardHeader } from '@coreui/react'

import SavePatientDiagnosisData from '../../services/general/savePatientDiagnosisData.api.js'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'

import React, { useRef, useState, useEffect } from 'react'
import SavePatients from '../../services/general/savePatientinformation.api'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api.js'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'

export const Questions = ({ patientData, saveQuestions }) => {
  const [render, setRender] = useState(false)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [patientDiagnosisList, setPatientDiagnosisList] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [newDiagnosis, setNewDiagnosis] = useState([])
  const [visible, setVisible] = useState(false)
  const [formAnswers, setFormAnswers] = useState([])
  const [validComponents, setValidComponents] = useState([])
  const [validDiagnosis, setValidDiagnosis] = useState([])

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = data.Data.map((obj) => ({
      value: obj.id,
      label: obj.Name.trim(),
    }))
    setDiagnosisData(options)
  }

  const GetPatientDiagnosis = async () => {
    try {
      const response = await ModifyPatientMap('GETALL', patientData.PatientID)
      const formattedDiagnosis = JSON.parse(response.d)
      const formattedDiagnosisAll = formattedDiagnosis?.Data.filter((obj) => obj.PatientID === patientData.PatientID) || []
      const patientDetails = Array.isArray(formattedDiagnosisAll) ? formattedDiagnosisAll[0] : {}
      const patientDetailsDiagnosis = patientDetails.Diagnosis ? (patientDetails.Diagnosis.includes(',') ? patientDetails.Diagnosis.split(',') : [patientDetails.Diagnosis]) : []

      setPatientDiagnosisList(patientDetailsDiagnosis)
      setRender((p) => !p)
    } catch (error) {
      console.error('Error fetching patient diagnosis:', error)
    }
  }

  useEffect(() => {
    getData()
    GetPatientDiagnosis()
  }, [])

  useEffect(() => {
    fetchData()
  }, [render])

  const fetchData = async () => {
    const allComponents = []
    const validDiagnosisList = []

    for (let diagnosis of patientDiagnosisList) {
      try {
        formData.current.push([])
        const response = await GetQuestionBank('', diagnosis, '')
        const component = JSON.parse(response.d)
        allComponents.push(component)
        validDiagnosisList.push(diagnosis)
      } catch (e) {
        console.error('Error fetching question bank:', e)
      }
    }

    try {
      const tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
      const data = JSON.parse(tempAnswers.d)
      const formAnswersStr = data.Data.length > 0 ? data.Data[0].DiagnosisDetails : '[]'
      const tempData = JSON.parse(formAnswersStr)
      setFormAnswers(tempData)
    } catch (e) {
      console.error('Error fetching patient diagnosis details:', e)
    }

    setValidComponents(allComponents)
    setValidDiagnosis(validDiagnosisList)
  }

  const formData = useRef([])

  const addDiagnosis = () => {
    setVisible(true)
  }
  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const handleModalSave = async () => {
    let treatmentNotesData = await PatientNoteDataCRUD('GET', patientData.PatientID)

    if (treatmentNotesData) {
      treatmentNotesData = JSON.parse(treatmentNotesData.d)?.Data

      treatmentNotesData = treatmentNotesData.map((item) => {
        return {
          ...item,
          data: item.data ? JSON.parse(item?.data) : {},
        }
      })
    }

    let takeLatestNote = treatmentNotesData[treatmentNotesData.length - 1]
    const findIdDiagnosis = diagnosisData.find((item) => item.label === selectedDiagnosis)

    console.log(findIdDiagnosis, 'findIdDiagnosis')

    console.log('takeLatestNote before', takeLatestNote)

    if (findIdDiagnosis && takeLatestNote) {
      const currentIds = takeLatestNote.data?.metadata?.diagnosisIds || []
      let statusTakeLatestNote = takeLatestNote?.status || 'Draft'
      let noteSetId = takeLatestNote?.id || null

      // Create a Set to ensure uniqueness
      const uniqueDiagnosisIds = Array.from(new Set([...currentIds, findIdDiagnosis.value]))
      let newDiagnosis = [findIdDiagnosis.label]

      let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
        let existingData = takeLatestNote.information?.[item] || []

        if (!existingData.includes('Call Center')) {
          acc[item] = [...existingData, 'Call Center']
        } else {
          acc[item] = existingData
        }

        return acc
      }, {})
      takeLatestNote = {
        ...(takeLatestNote.data || {}), // start with existing data

        // Merge and update metadata with unique diagnosisIds
        metadata: {
          ...(takeLatestNote.data?.metadata || {}),
          diagnosisIds: uniqueDiagnosisIds,
        },

        // Merge and update information object with updated historyDiagnosis
        information: {
          ...(takeLatestNote.data?.information || {}),
          ...historyDiagnosis,
        },
      }

      console.log(takeLatestNote, 'takeLatestNote after')

      await PatientNoteDataCRUD('UPDATE', patientData?.PatientID?.toString(), noteSetId, JSON.stringify(takeLatestNote), getFormattedDate().toString(), statusTakeLatestNote || 'Draft', takeLatestNote.flag === 'false' ? false : true)
    }

    const diagnosisUniqueSet = new Set(patientDiagnosisList)

    if (diagnosisUniqueSet.has(selectedDiagnosis)) {
      toast.error('Diagnosis Already Exists', toastConfig)
      return
    }

    setNewDiagnosis((p) => [...p, selectedDiagnosis])
    diagnosisUniqueSet.add(selectedDiagnosis)

    const allUniqueDiagnosis = Array.from(diagnosisUniqueSet).filter((item) => item.id !== '')
    setPatientDiagnosisList(allUniqueDiagnosis)

    await ModifyPatientMap('UPDATE', patientData.PatientID, allUniqueDiagnosis.join(','))
    setVisible(false)
    setRender((p) => !p)
  }

  const diagnosisChanged = (e) => {
    setSelectedDiagnosis(e.label)
  }

  const convertUpper = (str) => {
    const arr = str.split(' ')
    for (let i = 1; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1)
    }
    return arr.join('')
  }

  const handleFormSubmit = async () => {
    let idNumber = patientData.PatientID
    let resp = await SavePatientDiagnosisData(idNumber, patientDiagnosisList.join(','), JSON.stringify(formData.current), 'Completed')
    saveQuestions(patientDiagnosisList.join(','))
    // history.push("/dashboard/callcenter")
  }

  const handleDeleteDiagnosis = async (diagnosisToDelete, indexComponent) => {
    try {
      if (!newDiagnosis.includes(diagnosisToDelete)) {
        toast.error('Cannot delete previously added diagnosis', toastConfig)
        return
      }

      const index = patientDiagnosisList.findIndex((d) => d === diagnosisToDelete)

      if (index === -1) {
        toast.error('Diagnosis not found in the list', toastConfig)
        return
      }

      setPatientDiagnosisList(patientDiagnosisList.filter((d) => d !== diagnosisToDelete))

      setNewDiagnosis(newDiagnosis.filter((d) => d !== diagnosisToDelete))

      const updatedValidComponents = validComponents.filter((_, i) => i !== indexComponent)

      setValidComponents(updatedValidComponents)

      const updatedDiagnosisList = patientDiagnosisList.filter((d) => d !== diagnosisToDelete)

      await ModifyPatientMap('UPDATE', patientData.PatientID, updatedDiagnosisList.join(','))

      GetPatientDiagnosis()

      // await fetchQuestionWithFormAnswer();
    } catch (e) {
      console.error('Error deleting diagnosis:', e)
    }
  }

  const { PatientID, FirstName, MiddleName, LastName, Gender, EmergencyName, EmergencyPhone, Room, FacilityName, PhoneNumber } = patientData
  const PatientName = FirstName + ' ' + LastName

  return (
    <>
      <CCard className="" style={{ marginBottom: '10px' }}>
        <div className="">
          <CCardBody className="">
            <CRow className="mb-3">
              <CFormLabel className="col-sm-1 col-form-label">Patient Name:</CFormLabel>
              <CCol sm={10}>
                <CFormInput type="text" id="staticEmail" style={{ fontWeight: 'bold' }} defaultValue={PatientName} readOnly plainText />
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label">Power of Attorney Name:</CFormLabel>
              <CCol sm={10}>
                <CFormInput type="text" id="staticEmail" style={{ fontWeight: 'bold' }} defaultValue={EmergencyName} readOnly plainText />
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label">Power of Attorney Contact Number:</CFormLabel>
              <CCol sm={10}>
                <CFormInput type="text" id="staticEmail" style={{ fontWeight: 'bold' }} defaultValue={EmergencyPhone} readOnly plainText />
              </CCol>
              <CFormLabel className="col-sm-2 col-form-label">All Diagnosis:</CFormLabel>
              <CCol sm={10}>
                <CFormInput type="text" id="staticEmail" style={{ fontWeight: 'bold' }} defaultValue={patientDiagnosisList ? patientDiagnosisList.join(',') : ''} readOnly plainText />
              </CCol>
            </CRow>
            <CButton color="primary" style={{ marginBottom: '10px', color: 'white' }} onClick={addDiagnosis}>
              + Add Diagnosis
            </CButton>
            <CButton color="success" style={{ marginBottom: '10px', marginLeft: '10px', color: 'white' }} onClick={handleFormSubmit}>
              Submit
            </CButton>
          </CCardBody>
        </div>
      </CCard>

      <CAccordion>
        {validComponents.map((obj, i) => (
          <CContainer key={i} className="d-flex mw-100 align-items-center gap-4">
            <CAccordionItem className="w-100" itemKey={i}>
              <CAccordionHeader>{validDiagnosis[i]}</CAccordionHeader>
              <CAccordionBody>
                <Form
                  key={i}
                  form={obj}
                  submission={formAnswers[i]}
                  onChange={(e) => {
                    formData.current[i] = { data: e.data }
                  }}
                />
              </CAccordionBody>
            </CAccordionItem>
            {newDiagnosis.includes(validDiagnosis[i]) && (
              <CButton className="text-white" style={{ height: 'min-content' }} onClick={() => handleDeleteDiagnosis(validDiagnosis[i], i)} color="danger">
                Delete
              </CButton>
            )}
          </CContainer>
        ))}
      </CAccordion>

      <CModal visible={visible} onClose={() => setVisible(false)} backdrop="static" keyboard={false} portal={false}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>New Diagnosis</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <CFormLabel>Select Diagnosis</CFormLabel>
            <Select
              placeholder="Select"
              onChange={(e) => {
                diagnosisChanged(e)
              }}
              options={diagnosisData}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={handleModalSave}>
            Add
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
